import { render, staticRenderFns } from "./proof-view-comments.vue?vue&type=template&id=2073ac66&scoped=true&"
import script from "./proof-view-comments.vue?vue&type=script&lang=js&"
export * from "./proof-view-comments.vue?vue&type=script&lang=js&"
import style0 from "./proof-view-comments.vue?vue&type=style&index=0&id=2073ac66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2073ac66",
  null
  
)

export default component.exports